<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.schemas` | trans }}
    </h1>
    <v-app id="vuetify-app">
      <v-tabs icons-and-text v-model="selectedTab" slider-color="success">
        <v-tab>
          {{ `app.pages.home.menu` | trans }}
          <v-icon>calendar_today</v-icon>
        </v-tab>
        <v-tab>
          {{ `app.patients.prescriptions` | trans }}
          <v-icon>add_to_queue</v-icon>
        </v-tab>
        <v-tab>
          {{ `app.patients.surveys` | trans }}
          <v-icon>forum</v-icon>
        </v-tab>
        <v-tab-item :key="`schemas`">
          <schemas-page></schemas-page>
        </v-tab-item>
        <v-tab-item :key="`prescriptions`">
          <prescriptions-table ref="prescriptionsPatients"/>
        </v-tab-item>
        <v-tab-item :ke="`surveys`">
          <surveys-table ref="surveysPatients"/>
        </v-tab-item>
      </v-tabs>
    </v-app>
  </base-layout>
</template>
<script>

export default {
  props: {
    tab: Number
  },
  data: () => ({
    selectedTab: 0,
  }),
  async created() {
    this.selectedTab = this.tab;
  },
  watch: {
    selectedTab: {
      handler() {
        if (this.selectedTab === 1) {
          this.$refs.prescriptionsPatients.fetchData();
        }
        if (this.selectedTab === 2) {
          this.$refs.surveysPatients.fetchData();
        }
      }
    }
  }
}
</script>
